import * as React           from 'react'

import Grid             from '@material-ui/core/Grid'

import { PersonalInfo }              from '../../../api'
import { FormikFormChunkProps }      from '../../../types'
import { AbstractedFormikTextField } from '../../atoms'

const EditPersonalChunk: React.SFC<FormikFormChunkProps<PersonalInfo>> = props => {

  return (
    <Grid container spacing={16}>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          disabled
          identifier={'name'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          disabled
          identifier={'surname'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          disabled
          identifier={'email'}
          {...props}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AbstractedFormikTextField
          fullWidth
          disabled
          identifier={'employeeId'}
          {...props}
        />
      </Grid>
    </Grid>
  )
}

export default EditPersonalChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/EditPersonalChunk.tsx